module.exports = __webpack_public_path__ + "static/media/peertoboss.4124eeaa.png";